import React from 'react';
import classNames from 'classnames';
import { HyperdbListing } from '../../../../hyperdb';
import { displayLocalDate } from '../../../../helpers/date';

export default HyperdbListing({
  collectionName: 'reservations',
  namespace: 'reservation',
  mountedUrl: '/daily-rental/reservations',
  title: 'Reservations',
  columns: [
    { attribute: 'reference' },
    { attribute: 'creation_date', label: 'date', value: (o) => displayLocalDate(o.creation_date) },
    { attribute: 'status' },
    { attribute: 'amount_paid', label: 'amount paid', value: (o) => <span>{ o.amount_paid ? o.amount_paid.toFixed(2) : '' } { o.deposit_paid ? <i className="fas fa-check" /> : null }</span> },
    { attribute: 'property.name', label: 'property' },
    { attribute: 'customer.name', label: 'customer' },
    { attribute: 'arrival_date', label: 'arrival' },
    { attribute: 'departure_date', label: 'departure' },
    { attribute: 'origin' },
  ],
  useQuickSearch: true,
  filters: [
    { value: 'new' },
    { value: 'requested' },
    { value: 'offered' },
    { value: 'accepted' },
    { value: 'recent_prereservations' },
    { value: 'earlier_prereservations' },
    { value: 'to_validate' },
    { value: 'confirmed' },
    { value: 'not_printed' },
    { value: 'rejected' },
    { value: 'aborted' },
    { value: 'canceled' },
    { value: 'error' },
  ],
  defaultSort: ['creation_date', 'desc'],
  advancedFilters: {
    creation_date: { type: 'date', label: 'date' },
    arrival_date: { type: 'date', label: 'arrival' },
    departure_date: { type: 'date', label: 'departure' },
    'property.id': { // HACK: can remove when fix hyperdbquery to put deep nested relations in joins
      type: 'text',
      label: 'group',
      value: { cond: 'ne', text: 1 },
      hide: true,
    },
    'property.owner.id': {
      type: 'relation',
      label: 'owner',
      fetchData: (props) => {
        props.api.owner.getObjects({
          propName: 'ownersForFilterReservations',
          queryOptions: [['name'], { order: { name: 'asc' } }],
        });
      },
      options: (props) => {
        const owners = props.api.getState('owner').ownersForFilterReservations || [];
        return owners.map(o => ({ name: o.name, value: o.id }));
      },
    },
    'property.group.id': {
      type: 'relation',
      label: 'group',
      fetchData: (props) => {
        props.api.propertyGroup.getObjects({
          propName: 'groupsForFilterReservations',
          queryOptions: [['name'], { order: { name: 'asc' } }],
        });
      },
      options: (props) => {
        const groups = props.api.getState('propertyGroup').groupsForFilterReservations || [];
        return groups.map(g => ({ name: g.name, value: g.id }));
      },
    },
  },
  onEdit: (object, props) => props.api.routing.redirect(props.router, `/daily-rental/reservations/${object.id}/edit`),
  canShow: true,
  canExportCsv: true,
  batchPrint: true,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/reservation/containers/Listing.jsx